import { Component } from "react";
import { connect } from "react-redux";
import DataTable from "components/DigiHapi/DataTable";
import { bindActionCreators } from "redux";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// DigiHapi components
import MDWizard from "components/DigiHapi/MDWizard";
import DeleteConfirmationDialog from "components/DigiHapi/DeleteConfirmationDialog";
import SnackBarContainer from "components/DigiHapi/SnackBarContainer";

import { MdLocationCity } from "react-icons/md";
import {
	fetchGetCityDetails,
	fetchGetCitiesNames,
	fetchDeleteCity,
	fetchAddCity,
	fetchUpdateCity
} from "actions/city";
import { fetchGetCommunityDetails } from "actions/community";
import {
	RESET_CITY,
	SET_CITIES_NAME_FILTER,
	SET_CITIES_SORTED,
	SET_DELETE_CITY_CONFIRMATION_NAME
} from "actions/types";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";

class CitiesWizard extends Component {
	fetchAddCity = () => {
		const {
			fetchAddCity,
			name,
			customUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channels,
			collectWeather
		} = this.props;

		fetchAddCity({
			name,
			customUri,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			registerkey,
			files,
			channelsIds: Object.values(channels),
			collectWeather
		});
	};

	fetchUpdateCity = () => {
		const {
			fetchUpdateCity,
			_id,
			name,
			customUri,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			photoUri,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channels,
			collectWeather
		} = this.props;

		fetchUpdateCity({
			_id,
			name,
			customUri,
			registerkey,
			address,
			zipCode,
			city,
			webSiteUrl,
			mail,
			loc,
			phone,
			fax,
			files,
			photoUri,
			logoUri,
			mapUri,
			mapSmallUri,
			equipmentsIds,
			channelsIds: Object.values(channels),
			collectWeather
		});
	};

	render() {
		const { update, isFetching, onClose } = this.props;
		return (
			<Grid item xs={12}>
				<MDWizard
					onClose={onClose}
					isFetching={isFetching}
					validate
					steps={[
						{
							stepName: "Illustration",
							stepComponent: Step1,
							stepId: "picture"
						},
						{
							stepName: "Informations",
							stepComponent: Step2,
							stepId: "infos"
						},
						{
							stepName: "Localisation",
							stepComponent: Step3,
							stepId: "localisation"
						}
					]}
					title={update ? "Mise à jour d'une ville" : "Ajout d'une ville"}
					finishButtonClick={update ? this.fetchUpdateCity : this.fetchAddCity}
				/>
			</Grid>
		);
	}
}

class CitiesPage extends Component {
	state = {
		wizard: null,
		alert: null,
		name: "",
		cityToDelete: null
	};

	componentDidMount() {
		this.props.fetchGetCities();
	}

	componentDidUpdate(prevProps, prevState) {
		const {
			fetchGetCities,
			snackInfoMsg,
			newWizard,
			page,
			limit,
			sorted,
			nameFilter
		} = this.props;

		if (snackInfoMsg && prevProps.snackInfoMsg !== snackInfoMsg) {
			this.setState({
				wizard: null
			});
			fetchGetCities(page, limit, sorted, nameFilter);
		}

		if (newWizard && prevProps.newWizard !== newWizard) {
			this.addWizard(newWizard === "update");
		}
	}

	onClose = () => {
		this.setState({
			wizard: null
		});
		this.props.dispatch({
			type: RESET_CITY
		});
	};

	addWizard = (update = true) => {
		this.setState({
			wizard: <ConnectedCitiesWizard update={update} onClose={this.onClose} />
		});
	};

	changeCommunity = id => {
		this.props.fetchGetCommunityDetails(id);
	};

	editCity = id => {
		this.props.fetchGetCityDetails(id);
	};

	deleteCity = id => {
		this.props.fetchDeleteCity(id, this.props.deleteConfirmationName);
	};

	getRoundButtons = (id, name) => {
		return [
			{
				color: "success",
				icon: "where_to_vote",
				onClick: this.changeCommunity
			},
			{
				color: "info",
				icon: "edit",
				onClick: this.editCity
			},
			{
				color: "error",
				icon: "delete",
				onClick: this.delete
			}
		].map(prop => (
			<MDButton
				key={prop.icon}
				variant="gradient"
				color={prop.color}
				size="small"
				iconOnly
				circular
				disabled={!!this.state.wizard}
				onClick={() => prop.onClick(id, name)}
				sx={{ mx: 0.25 }}
			>
				<Icon>{prop.icon}</Icon>
			</MDButton>
		));
	};

	getCities = () => {
		const { citiesNames } = this.props;

		const citiesObj = Object.values(citiesNames).map(({ _id, name }) => {
			return {
				name,
				actions: (
					<MDBox display="flex" justifyContent="flex-end">
						{this.getRoundButtons(_id, name)}
					</MDBox>
				)
			};
		});
		return citiesObj;
	};

	delete = (cityId, cityName) => {
		this.setState({ cityToDelete: { cityId, cityName } });
	};

	render() {
		const { alert, cityToDelete } = this.state;
		const {
			isFetchingList,
			dispatch,
			page,
			totalPages,
			limit,
			sorted,
			fetchGetCities,
			nameFilter,
			snackInfoMsg,
			snackErrorMsg
		} = this.props;

		return (
			<SnackBarContainer
				snackInfoMsg={snackInfoMsg}
				snackErrorMsg={snackErrorMsg}
			>
				<Grid container spacing={3} justifyContent="center">
					{alert}
					<Grid item xs={12}>
						<Card>
							<MDBox
								mx={2}
								mt={-3}
								py={2}
								px={2}
								variant="gradient"
								bgColor="primary"
								borderRadius="lg"
								coloredShadow="primary"
								display="flex"
								alignItems="center"
								color="white"
							>
								<MdLocationCity size={24} />
								<MDTypography variant="h6" color="white" ml={1.5}>
									Villes
								</MDTypography>
							</MDBox>
							<MDBox p={2}>
								<DataTable
									data={this.getCities()}
									filterable
									columns={[
										{
											Header: "Nom",
											accessor: "name",
											sortable: true,
											filterable: true
										},
										{
											Header: "Actions",
											accessor: "actions",
											sortable: false,
											filterable: false
										}
									]}
									showPaginationTop
									showPaginationBottom={false}
									manual
									manualFilters
									onFetchData={state => {
										if (
											page !== state.page + 1 ||
											limit !== state.pageSize ||
											sorted !== state.sorted ||
											nameFilter !== state.filtered?.[0]?.value
										) {
											dispatch({
												type: SET_CITIES_SORTED,
												value: state.sorted
											});
											dispatch({
												type: SET_CITIES_NAME_FILTER,
												value: state.filtered?.[0]?.value
											});
											fetchGetCities(
												state.page + 1,
												state.pageSize,
												state.sorted,
												state.filtered?.[0]?.value
											);
										}
									}}
									loading={isFetchingList}
									defaultPageSize={limit}
									defaultSorted={sorted}
									page={page - 1}
									pageSizeOptions={[5, 10, 15, 20, 40, 80]}
									pages={totalPages}
									previousText="Précédent"
									nextText="Suivant"
									rowsText="Lignes"
									noDataText="Aucunes villes"
									ofText="sur"
									loadingText="Chargement..."
								/>
							</MDBox>
							<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
								<MDButton
									variant="gradient"
									color="primary"
									onClick={() => this.addWizard(false)}
									disabled={Boolean(this.state.wizard)}
								>
									<Icon>add</Icon>
									&nbsp;{"Ajout d'une ville"}
								</MDButton>
							</MDBox>
						</Card>
					</Grid>
					{this.state.wizard}
				</Grid>
				<DeleteConfirmationDialog
					open={!!cityToDelete}
					message="Êtes-vous sûr de vouloir supprimer la ville ?"
					instruction={`Confirmer la suppression de la ville en saisisant le nom de la ville ${
						cityToDelete?.cityName || ""
					}`}
					inputLabel="Ville ..."
					inputId="city"
					onInputChange={e =>
						dispatch({
							type: SET_DELETE_CITY_CONFIRMATION_NAME,
							value: e.target.value
						})
					}
					onCancel={() => this.setState({ cityToDelete: null })}
					onConfirm={() => {
						this.deleteCity(cityToDelete.cityId);
						this.setState({ cityToDelete: null });
					}}
				/>
			</SnackBarContainer>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		photoUri,
		customUri,
		citiesNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		collectWeather
	} = state.cityReducer;

	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		address,
		zipCode,
		city,
		webSiteUrl,
		mail,
		loc,
		phone,
		fax,
		registerkey,
		files,
		snackInfoMsg,
		snackErrorMsg,
		logoUri,
		mapUri,
		mapSmallUri,
		newWizard,
		equipmentsIds,
		deleteConfirmationName,
		channels,
		photoUri,
		customUri,
		citiesNames,
		page,
		hasNextPage,
		nextPage,
		totalPages,
		totalDocs,
		limit,
		sorted,
		nameFilter,
		collectWeather
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetCities: fetchGetCitiesNames,
			fetchGetCityDetails,
			fetchDeleteCity,
			fetchAddCity,
			fetchUpdateCity,
			fetchGetCommunityDetails
		},
		dispatch
	);
	return { ...actions, dispatch };
};

const ConnectedCitiesWizard = connect(
	mapStateToProps,
	mapDispatchToProps
)(CitiesWizard);

export default {
	CitiesPage: connect(mapStateToProps, mapDispatchToProps)(CitiesPage),
	CitiesWizard: ConnectedCitiesWizard
};
